import { Component, computed, input } from '@angular/core';

import { LabelPillComponent } from '@shared/components/label-pill/label-pill.component';
import {
  PillClickEvent,
  PillsOverflowComponent
} from '@shared/components/pills-overflow/pills-overflow.component';
import { keyValueToPillItems } from '@shared/components/pills-overflow/pills-overflow.utils';
import {
  formatCellValue,
  formatMapNumber,
  processKeyValueMap
} from '@shared/components/table/table-cell/utils';

import { CellOverlayAction } from '../../actions-overlay/actions-overlay.component';

type KeyValueMapCellValue = string | number;

@Component({
  selector: 'app-key-value-map-cell',
  imports: [PillsOverflowComponent, LabelPillComponent],
  templateUrl: './key-value-map-cell.component.html'
})
export class KeyValueMapCellComponent {
  availableCellActions: CellOverlayAction[] = [];
  availableCellShiftActions: CellOverlayAction[] = ['copy_raw'];
  valueAsString = (v: unknown) => formatCellValue(v, 'string-number-map');

  value = input<unknown | undefined>(undefined);

  protected processedValue = computed<Record<string, KeyValueMapCellValue>>(() => {
    return processKeyValueMap(this.value());
  });

  protected entries = computed<[string, KeyValueMapCellValue][]>(() =>
    Object.entries(this.processedValue())
  );

  protected pillItems = computed(() => {
    const entries = this.entries();
    return keyValueToPillItems(entries);
  });

  protected onPillClick(
    event: PillClickEvent<{ key: string; value: KeyValueMapCellValue }>
  ): void {
    this.onKeyValueClick(event.data.key);
  }

  /* eslint-disable-next-line @typescript-eslint/no-unused-vars */
  protected onKeyValueClick(key: string): void {}

  protected formatValue(value: KeyValueMapCellValue): string {
    return formatMapNumber(value);
  }
}
